import { Injectable } from '@angular/core';
import { CanActivate, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { Router } from '@angular/router';
import { Location, DatePipe } from '@angular/common';
import { UserSessionService } from 'src/app/services/usersession.service';
import { AuthenticationService } from 'src/app/services/authentication.service';

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(private router: Router,
    private _location: Location,
    private authendicationService: AuthenticationService,
    private userSessionService: UserSessionService,) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    let menuItems = [];
    const paths = [];
    const menu = this.userSessionService.getLocalStorageWithKey('menu');
    if (menu) {
      menuItems = JSON.parse(menu);
    }
    if (localStorage.getItem('isLoggedin')) {
      if (state.url === '/dashboard' && this.userSessionService.roleId() != 510) return true;
      if (state.url.includes('/bulk-permit-monitoring')) return true;
      if (state.url.includes('/enforcement') || state.url.includes('/vehicle-seizure') || state.url.includes('/illicit-mining') || state.url.includes('/lease-inspection') || state.url.includes('/penalty-vehicle-status')) return true;
      if (menuItems && menuItems.length > 0 && localStorage.getItem('isLoggedin')) {
        menuItems.forEach(field => {
          if (field.link) {
            paths.push(field.link);
            return true;
          }
          if (field.subItems && field.subItems.length > 0) {
            field.subItems.forEach(sm => { if (sm.link) { paths.push(sm.link); } });
          }
        });
        if (paths.indexOf(state.url) >= 0) {
          return true;
        } else {
          const urls = state.url.split('/');
          if (urls.length > 1 && paths.indexOf('/' + urls[1]) >= 0) {
            return true;
          }
          else {
            this._location.back();
            return true;
            //this.authendicationService.logOut();
          }
        }
      }
    } else {
      this.authendicationService.logOut();
      this.router.navigate(['/auth']);
    }
    this.authendicationService.logOut();
    this.router.navigate(['/auth']);
    // this.router.navigate(['/auth'], { queryParams: { returnUrl: state.url } });
    return true;
  }
}